import { orchestrator } from 'satcheljs';
import Folder from 'owa-service/lib/contract/Folder';
import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import findFolders from '../services/findFolders';
import {
    fetchArchiveDumpsterFolder,
    onFindDumpsterFolderSuccess,
} from '../actions/internalActions';
import { addFolderToDefaultFolderMappings } from 'owa-session-store';
import {
    ARCHIVE_DUMPSTER_DISTINGUISHED_ID,
    ARCHIVE_FOLDERS_TREE_TYPE,
} from '../util/folderConstants';
import getDefaultAnchorMailboxForHeaders from '../util/getDefaultAnchorMailboxForHeaders';

/**
 * An orchestrator that gets the dumpster folder for archive mailbox and add mapping to session store.
 */
export default orchestrator(fetchArchiveDumpsterFolder, async () => {
    const findFolderResponse = await findFolders(
        distinguishedFolderId({ Id: ARCHIVE_DUMPSTER_DISTINGUISHED_ID })
    );
    if (
        !findFolderResponse ||
        !findFolderResponse.RootFolder ||
        !findFolderResponse.RootFolder.Folders ||
        !findFolderResponse.RootFolder.ParentFolder
    ) {
        return;
    }

    onFindDumpsterFolderSuccess(
        findFolderResponse.RootFolder,
        ARCHIVE_FOLDERS_TREE_TYPE,
        getDefaultAnchorMailboxForHeaders()
    );

    const dumpsterFolder: Folder = findFolderResponse.RootFolder.ParentFolder;

    addFolderToDefaultFolderMappings(
        dumpsterFolder.DistinguishedFolderId,
        dumpsterFolder.FolderId.Id
    );
});
